import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SiInfoPageComponent } from '@siemens/element-ng/info-page';

@Component({
  selector: 'app-access-denied',
  imports: [CommonModule, SiInfoPageComponent],
  templateUrl: './access-denied.component.html',
  styleUrl: './access-denied.component.scss'
})
export class AccessDeniedComponent {
  // This component is intentionally simple with no additional logic.
  // All content is managed through the template.
}
